// Service
import {
  HTTP_SUCCESS_CODE_400,
  HTTP_SUCCESS_STATUS_CODES,
} from "../../../constants/VorgangDetailsConstants";
import { pluginsService } from "../../services/plugins/pluginsService";

function getPluginsByCategorySuccess(resp) {
  return {
    type: "GET_PLUGINS_BY_CATEGORY_SUCCESS",
    resp,
  };
}

function getPluginsByCategory(categoryId) {
  return async (dispatch) => {
    const resp = await pluginsService.getPluginsByCategory(categoryId);
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      dispatch(getPluginsByCategorySuccess(resp));
      return resp;
    }
  };
}

// Plugin Details
function getPluginDetailsSuccess(resp) {
  return {
    type: "GET_PLUGINS_DETAILS_SUCCESS",
    resp,
  };
}

function getPluginsDetails(pluginId) {
  return async (dispatch) => {
    const resp = await pluginsService.getPluginsDetails(pluginId);
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      dispatch(getPluginDetailsSuccess(resp));
      return resp;
    }
  };
}

function updatePluginStatusSuccess(pluginId) {
  return {
    type: "UPDATE_PLUGIN_DETAILS_BY_STATUS_SUCCESS",
    payload: pluginId,
  };
}

// Plugin Status Update
function updatePluginStatus(enabled, pluginId, isDetailView = false) {
  return async (dispatch) => {
    const resp = await pluginsService.updatePluginStatus(enabled, pluginId);
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      dispatch(updatePluginStatusSuccess(pluginId));
      if (isDetailView) {
        dispatch(updatePluginStatusSuccess(pluginId));
      }
      return resp;
    }
  };
}

function updatePluginCustomerPreviewDetailsSuccess(resp) {
  return {
    type: "UPDATE_PLUGIN_CUSTOMER_PREVIEW_DETAILS_SUCCESS",
    resp,
  };
}

function updatePluginCustomerPreviewDetails(data, requestId) {
  return async (dispatch) => {
    const resp = await pluginsService.updatePluginCustomerPreviewDetails(
      data,
      requestId
    );
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      dispatch(updatePluginCustomerPreviewDetailsSuccess(data));
      return resp;
    } else if (HTTP_SUCCESS_CODE_400 === resp?.response?.status) {
      return resp?.response;
    }
  };
}

// Plugin Details
function getQESProvidersSuccess(resp) {
  return {
    type: "GET_QES_PROVIDERS_SUCCESS",
    resp,
  };
}

function getQESProviders() {
  return async (dispatch) => {
    const resp = await pluginsService.getQESProviders();
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      dispatch(getQESProvidersSuccess(resp));
      return resp;
    }
  };
}

export const pluginActions = {
  // Added for unit testcases
  getPluginsByCategorySuccess,
  getQESProvidersSuccess,

  getPluginsByCategory,
  getPluginsDetails,
  getQESProviders,
  updatePluginStatus,
  updatePluginCustomerPreviewDetails,
};
